import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const FEATURED = [
  {
    title: "Sustainify Insights",
    desc: "Articles and resources on sustainability, innovation and future-forward thinking.",
    url: "https://sustainify.com.au/insights",
  },
  {
    title: "LinkedIn",
    desc: "Essays and perspectives on driving impactful change, shared along the journey.",
    url: "https://www.linkedin.com/in/rachellecooperkulkarni/",
  },
];

const WORKS = [
  { year: "2026", title: "Future Alchemy: Creating the Future", outlet: "Asia-Pacific Futures and Foresight Symposium — session", url: null },
  { year: "2026", title: "Ancient Wisdom to Steward Climate Resilience", outlet: "Disaster and Emergency Management Conference — session", url: null },
  { year: "2025", title: "Creating a Safe Future, Together", outlet: "Safer Together Conference — keynote", url: null },
  { year: "2025", title: "Competing in a Carbon-Constrained World: Climate Strategy as Competitive Advantage", outlet: "The Strategy Brief", url: null },
  { year: "2025", title: "Women Powering Renewables — Featured Spotlight", outlet: "Q&A Newsletter", url: null },
  { year: "2025", title: "Responsible Leadership and Circular Economy", outlet: "CQU Research Paper — interview", url: null },
  { year: "2024", title: "A Just Energy Transition in the Western Downs and South Burnett Regions — Summary Research Report", outlet: "Sustainify", url: "https://www.sustainify.com.au/resources" },
  { year: "2024", title: "Barriers and Enablers for a Just Energy Transition in Queensland's Western Downs and South Burnett — a Participatory Systems Mapping case study", outlet: "Masters Dissertation, Centre for Alternative Technology", url: null },
  { year: "2024", title: "First Nations Better Practice Community Engagement Toolkit", outlet: "The Energy Charter", url: "https://theenergycharter.my.canva.site/first-nations-better-practice-community-engagement-toolkit#toolkit-resources" },
  { year: "2024", title: "Understanding Impact & Legacy — Power Hour Virtual Forum", outlet: "Engaged Outcomes", url: "https://engagedoutcomes.com.au/power-hour-virtual-forum" },
];

export const Writing = () => (
  <section id="writing" data-testid="writing-section" className="bg-ink py-28 md:py-36">
    <div className="max-w-7xl mx-auto px-6 md:px-10">
      <Reveal>
        <p className="eyebrow text-gold">Writing & Insights</p>
        <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-tight mt-6 text-cream">
          Things I've <span className="italic text-gold">written</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid md:grid-cols-2 gap-6">
        {FEATURED.map((f, i) => (
          <Reveal key={f.title} delay={i * 0.08}>
            <a href={f.url} target="_blank" rel="noopener noreferrer"
              data-testid={`writing-featured-${f.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group block border border-gold/30 p-8 md:p-10 h-full hover:bg-gold/5 transition-colors duration-300">
              <ArrowUpRight className="text-gold mb-8 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" size={28} />
              <h3 className="font-display text-2xl md:text-3xl text-cream">{f.title}</h3>
              <p className="mt-3 text-cream/60 text-sm leading-relaxed">{f.desc}</p>
            </a>
          </Reveal>
        ))}
      </div>

      <div className="mt-16 border-t border-cream/15">
        {WORKS.map((w, i) => {
          const inner = (
            <>
              <span className="font-display text-gold text-lg w-16 shrink-0">{w.year}</span>
              <div className="flex-1">
                <h3 className="text-cream text-base md:text-lg leading-snug">{w.title}</h3>
                <p className="text-cream/50 text-sm mt-1">{w.outlet}</p>
              </div>
              {w.url && <ArrowUpRight className="link-arrow text-gold shrink-0" size={20} />}
            </>
          );
          const cls = "link-row flex items-start gap-6 py-6 border-b border-cream/15 px-2 -mx-2";
          return (
            <Reveal key={w.title} delay={Math.min(i * 0.04, 0.2)}>
              {w.url ? (
                <a href={w.url} target="_blank" rel="noopener noreferrer"
                  data-testid={`writing-item-${i}`} className={cls}>{inner}</a>
              ) : (
                <div data-testid={`writing-item-${i}`} className={cls}>{inner}</div>
              )}
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
